export function countPassengers(passengers, includedPassengerGroups) {
  if (!passengers) {
    return 0
  }
  let totalCount = 0
  for (let [passengerGroup, passengerCount] of Object.entries(passengers)) {
    if (includedPassengerGroups.has(passengerGroup)) {
      totalCount += Number(passengerCount) || 0
    }
  }
  return totalCount
}
